import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, CanLoad, UrlSegment, Route, CanDeactivate, UrlTree } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { ErrDialogComponent } from '../views/features/err-dialog/err-dialog.component';

import { AuthenticationService } from '../_services/authentication.service';
import { OrderComponent } from '../views/features/order/order.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanDeactivate<unknown>, CanLoad {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public dialogService: DialogService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    console.log(currentUser)

    if (currentUser) {
      if (currentUser.code === 200) {
        // logged in so return true
        return true;
      }
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login']);
    return false;
  }

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log(nextState.root.queryParams['nextState'])

    // 如果 nextState 存在，說明是由程序代碼進行的導航，直接返回 true 允許導航
    if (nextState.root.queryParams['nextState']) {
      // console.log(component, currentRoute, currentState, nextState)
      return true;
    }

    // 彈出確認提示框
    const userResponse = window.confirm('確定要離開此頁面？');

    // 根據用戶的選擇返回相應的值
    return userResponse;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    // console.log(this.authenticationService.getAuth())
    // const currentUser = this.authenticationService.currentUserValue;
    console.log(localStorage.getItem('auth-role'))
    console.log(route.path)
    let dynamicReturn = true;

    const isSales = localStorage.getItem('auth-role') === '"Sales_EMP"' || localStorage.getItem('auth-role') === '"Sales_Manager"' || localStorage.getItem('auth-role') === '"Sales_SIR"';
    const isFinance = localStorage.getItem('auth-role') === '"Finance_EMP"' || localStorage.getItem('auth-role') === '"Finance_ATTN"' || localStorage.getItem('auth-role') === '"Finance_SIR"';
    const isShipping = localStorage.getItem('auth-role') === '"Shipping_EMP"' || localStorage.getItem('auth-role') === '"Shipping_SIR"';
    const isAdmin = localStorage.getItem('auth-role') === '"admin"' || localStorage.getItem('auth-role') === '"GM"';

    if (isAdmin) {

    } else if (isSales) {

      switch (route.path) {
        // case 'bank':
        //   dynamicReturn = false
        //   this.router.navigate(['/main/dashboard']);
        //   break;

        case 'rbac':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'user':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'department':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'bpm':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;
      }
    } else if (isFinance) {

      switch (route.path) {

        case 'rbac':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'user':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'department':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'bpm':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;
      }
    } else if (isShipping) {

      switch (route.path) {

        case 'bank':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'rbac':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'user':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'department':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;

        case 'bpm':
          dynamicReturn = false
          this.router.navigate(['/main/dashboard']);
          break;
      }
    }

    if (!dynamicReturn) {
      this.openErrDialog('無路由權限，請洽相關人員')
    }

    console.log(dynamicReturn)
    return dynamicReturn;  //how can I return true dynamically?
  }

  openErrDialog(status: string) {
    const ref = this.dialogService.open(ErrDialogComponent, {
      data: {
        message: status
      },
      header: 'Error',
      width: '350px'
    });
  }

}
